import stateCityList from "./state_city_list.json";
import { useEffect, useRef, useState } from "react";

const ALL_STATES = stateCityList?.[0]?.states || [];

export default function PageFlipBar({ data, city, colors = {}, isGold = true }) {
  const [citiesOpen, setCitiesOpen] = useState(false);
  const cityRef = useRef(null);
  const [stateOpen, setStateOpen] = useState(false);
  const stateRef = useRef(null);
  useEffect(() => {
    const handleOutside = (e) => {
      if (cityRef.current && !cityRef.current.contains(e.target)) {
        setCitiesOpen(false);
      }
      if (stateRef.current && !stateRef.current.contains(e.target)) {
        setStateOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);
  const normalize = (str = "") =>
    str.toLowerCase().replace(/[\s-]+/g, " ").trim();

  const matchedState = ALL_STATES.find((s) => normalize(s.state) === normalize(city));
  const activeState =
    matchedState ||
    ALL_STATES.find((s) => s.cities.some((c) => normalize(c.city) === normalize(city)));
  const activeCity = matchedState
    ? null
    : activeState?.cities.find((c) => normalize(c.city) === normalize(city));

  const cityList = activeState?.cities || [];
  const priceSuffix = isGold ? "gold" : "silver";
  const basePath = isGold ? "gold-rates" : "silver-rates";

  return (
    <div className="w-full flex flex-col md:flex-row gap-1.5">
       <div className="flex-col gap-y-1 w-full md:w-1/3 relative" ref={stateRef}>
        <div
          onClick={() => setStateOpen((prev) => !prev)}
          className={`border ${colors.border} px-1.5 py-1 rounded-lg flex items-center justify-between gap-x-1.5 text-sm cursor-pointer select-none`}
        >
          <span className="p-1.5">{activeState ? activeState.state : "Select State Here"}</span>
          <span
            className={`transition-transform duration-200 text-xs ${stateOpen ? "rotate-180" : ""}`}
          >
            ▾
          </span>
        </div>
        <div
          className={`bg-white h-[220px] overflow-auto flex flex-col absolute z-10 w-full mt-1 rounded-lg border ${colors.border}   shadow-md transition-all duration-200 origin-top ${stateOpen ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0 pointer-events-none"}`}
        >
          {ALL_STATES
            .filter((s) => normalize(s.state) !== normalize(activeState?.state))
            .map((val) => (
              <a
                key={val.url}
                href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/${basePath}/${val.url}-${priceSuffix}-price-today`}
                className="w-full text-left px-3 py-2 text-sm"
              >
                {val.state}
              </a>
            ))}
        </div>
      </div>
       <div className="flex-col gap-y-1 w-full md:w-1/3 relative" ref={cityRef}>
        <div
          onClick={() => setCitiesOpen((prev) => !prev)}
          className={`border ${colors.border} px-1.5 py-1 rounded-lg flex items-center justify-between gap-x-1.5 text-sm cursor-pointer select-none`}
        >
          <span className="p-1.5">{activeCity ? activeCity.city : "Select City Here"}</span>
          <span
            className={`transition-transform duration-200 text-xs ${citiesOpen ? "rotate-180" : ""}`}
          >
            ▾
          </span>
        </div>
        <div
          className={`bg-white h-[220px] overflow-auto flex flex-col absolute z-10 w-full mt-1 rounded-lg border ${colors.border}   shadow-md transition-all duration-200 origin-top ${citiesOpen ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0 pointer-events-none"}`}
        >
          {cityList
            .filter((c) => normalize(c.city) !== normalize(activeCity?.city))
            .map((val) => (
              <a
                key={val.url}
                href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/${basePath}/${val.url}-${priceSuffix}-price-today`}
                className="w-full text-left px-3 py-2 text-sm"
              >
                {val.city}
              </a>
            ))}
        </div>
      </div>
      <div
        className={`${colors.lightBg} border ${colors.border} p-1 rounded-2xl flex items-center gap-1.5 w-full md:w-4/5 font-semibold`}
      >
        <a
          href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/gold-rates/${city.toLowerCase().split(" ").join("-")}-gold-price-today`}
          className={`${isGold ? colors.gradient : ""} rounded-2xl flex-1 py-1 text-center`}
        >
          Gold
        </a>
        <a
          href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/silver-rates/${city.toLowerCase().split(" ").join("-")}-silver-price-today`}
          className={`${!isGold ? colors.gradient : ""} rounded-2xl flex-1 py-1 text-center`}
        >
          Silver
        </a>
      </div>
     
    </div>
  );
}
